<div class="advisor-search-container">
  <div class="contract-properties-ad">
    <div class="header-item">
      <span class="labeled">CONTRATO:</span>
      <span class="value" data-recording-sensitive>{{ currentContract }}</span>
    </div>
  </div>
  <div
    class="advisor-search search"
    (clickOutside)="closeWhenOutsideClick($event)"
  >
    <input
      type="text"
      required
      maxlength="12"
      [(ngModel)]="typingContract"
      (ngModelChange)="searchContract()"
      [class.filled]="typingContract && typingContract.length > 0"
      title="Buscar contrato"
      (click)="$event.target.select()"
    />
    <label>Buscar contrato</label>
    <img
      src="/images/atm-icn-cancel.svg"
      class="icon-search icon-cancel"
      [ngClass]="typingContract && typingContract.length > 0 ? 'active' : ''"
      (click)="restoreSearch($event)"
    />
    <ul
      class="result-list"
      [class.active]="hasResults === true"
      *ngIf="hasResults === true"
    >
      <ng-container *ngFor="let item of curatedContractsList">
        <li
          tabindex="0"
          class="option"
          attr.data-tab="{{ item.contractId }}"
          attr.data-key="{{ item.contractId }}"
          (keyup)="navDown($event)"
          (click)="changeContract(item.contractId)"
        >
          <div
            class="name"
            [class.strong]="item.startsWith === true"
            data-recording-sensitive
          >
            {{ item.contractId }}
          </div>
        </li>
      </ng-container>
    </ul>
    <ul class="result-list" *ngIf="curatedContractsList.length === 0">
      <li class="option" *ngIf="hasResults === false && itsFirstTime === false">
        <div class="item">No se encontraron resultados</div>
      </li>
    </ul>
  </div>
</div>
